import React from 'react';
import Header from '../../components/EnvioMensajes/Header/Header'
import EnvioMensajesComponent from '../../components/EnvioMensajes/EnvioMensajes/EnvioMensajes'

const EnvioMensaje = () => {
    return (
      <div className= "contenedor-derecho-prefectos fade-in">
        <div>
            <Header />
        </div>
        <div>
            <EnvioMensajesComponent />
        </div>
      </div>
    );
  };
  
export default EnvioMensaje;

